import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { Package } from 'src/models';
import { RootState } from 'src/store';
import { packagesSelectors } from 'src/store/reducers/packages';

export const usePackages = (): Package[] => {
  const state = useSelector<RootState, RootState['packages']>(
    (state) => state.packages,
  );

  const packages = packagesSelectors.selectAll(state);

  useDebugValue(packages);

  return packages;
};

export const usePackagesWithoutVip = (): Package[] => {
  const state = useSelector<RootState, RootState['packages']>(
    (state) => state.packages,
  );

  const packages = packagesSelectors.selectAll(state);

  useDebugValue(packages);

  return packages.filter((p) => !p.vipAccess);
};

export const useHeadsetById = (packageId: string): Package | undefined => {
  const state = useSelector<RootState, RootState['packages']>(
    (state) => state.packages,
  );

  const pkg = packagesSelectors.selectById(state, packageId);

  useDebugValue(pkg);

  return pkg;
};
